import * as Yup from 'yup';

export const validateForm = async (formData: any, validationSchema: Yup.ObjectSchema<any>) => {
    try {
        await validationSchema.validate(formData, { abortEarly: false });
        return {};
    } catch (err) {
        if (err instanceof Yup.ValidationError) {
            const errors: { [key: string]: string } = {};
            err.inner.forEach((error) => {
                if (error.path) {
                    const path = error.path.replace(/\[(\d+)\]/g, '.$1');
                    errors[path] = error.message;
                }
            });
            return errors;
        }
        return {};
    }
};